import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { CreditCardFormComponent } from '../credit-card-form/credit-card-form.component';
import { ProfileService } from '../../shared-core/services/profile.service';
import { AddressEditComponent } from 'src/app/checkout/address-edit/address-edit.component';
import { Address, AddressType } from 'src/app/shared-core/models/checkout-data.model';
import AddCreditCardModel from 'src/app/shared-core/models/add-credit-card-model';
import { CheckoutService } from 'src/app/shared-core/services/checkout.service';
import { ActionResponse } from 'src/app/shared-core/models/action-response.model';

@Component({
    selector: 'app-add-payment-method-dialog',
    templateUrl: './add-payment-method-dialog.component.html',
    styleUrls: ['./add-payment-method-dialog.component.scss']
})
export class AddPaymentMethodDialogComponent implements OnInit, AfterViewInit {
    @Output()
    public hidden = new EventEmitter();

    @ViewChild('addPaymentMethodModal')
    public addPaymentMethodModal: ModalDirective;

    @ViewChild('creditCardFormComponent')
    public creditCardComponent: CreditCardFormComponent;

    @ViewChild('billingAddressComponent')
    public billingAddressComponent: AddressEditComponent;

    public billingAddress: Address = { 
        AddressType: AddressType.Billing
    } as Address;

    public billingAddresses: Map<string, string> = new Map<string, string>();
    public useExistingBillingAddress = false;
    public existingBillingAddressId = null;
    public setAsDefault = false;
    public forceNewAddress = false;
    public isReady = false;
    public isSaving = false;

    constructor(
        private _profileService: ProfileService,
        private _elementRef: ElementRef, 
        private _renderer: Renderer2,
        private _checkoutService: CheckoutService,
        private _toaster: ToastService
    ) { }

    public async ngOnInit(): Promise<void> {
        this._checkoutService.getProfileAddresses(AddressType.Billing).subscribe(addresses => {
            (addresses?.AddressList ?? []).forEach(async address => {
                var formattedAddress = [
                    `${address.FirstName} ${address.LastName}`.trim(),
                    address.Address_.trim(),
                    address.Address2?.trim() ?? '',
                    address.City.trim(),
                    address.StateProvinceName.trim(),
                    address.PostalCodeZip.trim(),
                    address.CountryName.trim(),
                ].filter(x => x).join(', ');

                this.billingAddresses.set(address.AddressID, formattedAddress);
            });

            if (this.billingAddresses.size > 0) {
                this.existingBillingAddressId = this.billingAddresses.keys().next().value;
                this.useExistingBillingAddress = true;
            }
            else {
                this.forceNewAddress = true;
            }

            this.isReady = true;
        });
    }

    public ngAfterViewInit(): void {
        // Modal appears behind backdrop unless its at top of DOM.
        this._renderer.insertBefore(document.body, this._elementRef.nativeElement, document.body.firstChild, true);
        this._elementRef.nativeElement.classList.add('vistekweb');

        this.addPaymentMethodModal.config = {
            backdrop: 'static',
        }

        this.addPaymentMethodModal.show();
    }

    public addPaymentMethod(ev: any) {
        const addressValid = this.existingBillingAddressId || this.billingAddressComponent.isValid();
        const creditCardValid = this.creditCardComponent.isValid();

        if (!addressValid || !creditCardValid) {
            ev.preventDefault();
            return;
        }

        const creditCard = this.creditCardComponent.getCreditCard();

        let model = {
            accountNumber: creditCard.accountNumber,
            expirationMonth: creditCard.expirationMonth,
            expirationYear: creditCard.expirationYear,
            cardCode: creditCard.cardCode,
            setAsDefault: this.setAsDefault
        } as AddCreditCardModel;

        if (this.existingBillingAddressId) {
            model = {
                ...model,
                billingAddressId: this.existingBillingAddressId
            };
        }
        else {
            const address = this.billingAddressComponent.getAddress();
            model = {
                ...model,
                billingFirstName: address.FirstName,
                billingLastName: address.LastName,
                billingCompany: address.Company,
                billingAddress: address.Address_,
                billingAddress2: address.Address2,
                billingCity: address.City,
                billingProvinceName: address.StateProvinceName,
                billingProvinceId: address.StateProvinceID,
                billingPostalCode: address.PostalCodeZip,
                billingCountryName: address.CountryName,
                billingCountryId: address.CountryID,
                billingPhone: address.Phone,
            }
        }

        this.isSaving = true;
        this._profileService.savePaymentMethod(model).subscribe((result: ActionResponse) => {
            if(result.isSuccess) {
                window.location.href = window.location.origin + window.location.pathname + '?Message=Successfully%20added%20new%20payment%20method'
            } else {
                this._toaster.error(result.error);
                this.isSaving = false;
            }
        });
    }

    public onUseExistingAddressChanged() {
        if (this.useExistingBillingAddress) {
            this.existingBillingAddressId = this.billingAddresses.keys().next().value;
        }
        else {
            this.existingBillingAddressId = null;
        }
    }

    public hideDialog(): void {
        this.addPaymentMethodModal.hide();
        setTimeout(() => this.hidden.emit(), 50);
    }
}